import { state } from './state';
/**
 * Preloads and transitions to the full-resolution image for a production.
 */
export function loadFullResolutionImage(picture, pictureOld, placeholderImg, placeholderImgOld, img) {

  const isDesktop = window.innerWidth >= 768;
  const useReducedImage = !window.prefersReducedMotion;

  const desktopSrc = useReducedImage
    ? img['reduced_motion_image_desktop'] ||
      img['full_image_desktop']
    : img['full_image_desktop'];

  const mobileSrc = useReducedImage
    ? img['reduced_motion_image_mobile'] ||
      img['full_image_mobile']
    : img['full_image_mobile'];

  const src = isDesktop ? desktopSrc : mobileSrc;

  placeholderImg.src = img['preload_image'];

  placeholderImg.style.opacity=1;
  placeholderImgOld.style.opacity=0.2;

  const fullOldImg=pictureOld.querySelector('img');
  if (fullOldImg) {
    fullOldImg.style.opacity=0;
  } else {
    console.log("no old img in", pictureOld);
  }
  const fullNewImg=picture.querySelector('img');
  if (fullNewImg) {
    fullNewImg.style.opacity=0;
  } else {
    console.log("no new img in", pictureOld);
  }

  if (state.selectTimer!==null) {
    window.clearTimeout(state.selectTimer);
    state.selectTimer=null;
  }
  state.selectTimer = setTimeout(()=>{
    const preloadImg = new Image();
    preloadImg.onload = () => {
      picture.innerHTML = `
        <source media="(min-width: 768px)" srcset="${desktopSrc}">
        <source media="(max-width: 767px)" srcset="${mobileSrc}">
      `;

      const fullImage = document.createElement('img');
      fullImage.src = src;
      picture.style.opacity = 1;
      fullImage.style.opacity = 0;
      fullImage.style.transition = 'opacity 0.3s ease';
      picture.appendChild(fullImage);

      setTimeout(() => (fullImage.style.opacity = '1'), 50);
    };
    preloadImg.onerror = () => console.error('Failed to load image:', src);
    preloadImg.src = src;
  }, 100);

}
